// import React, { useState, useEffect, useCallback } from "react";
// import {
//   Grid,
//   Card,
//   Button,
//   Modal,
//   TextField,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableRow,
//   Paper,
//   Switch,
//   Dialog,
//   DialogTitle,
//   DialogContent,
//   DialogContentText,
//   DialogActions,
//   Backdrop,
//   CircularProgress,
//   Alert,
//   Snackbar,
//   IconButton,
//   InputAdornment,
//   Autocomplete,
//   Box
// } from "@mui/material";
// import MDBox from "components/MDBox";
// import MDTypography from "components/MDTypography";
// import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
// import DashboardNavbar from "examples/Navbars/DashboardNavbar";
// import DeleteIcon from "@mui/icons-material/Delete"; // Import delete icon

// import Footer from "examples/Footer";
// import apiRequest from "../../apiRequest";
// import { endPoints } from "../../apis";

// function ServiceComponent() {
//   const [services, setServices] = useState([]);
//   const [openModal, setOpenModal] = useState(false);
//   const [isEditing, setIsEditing] = useState(false);
//   const [currentPage, setCurrentPage] = useState(1);
//   const [totalItems, setTotalItems] = useState(0);
//   const [totalPages, setTotalPages] = useState(1);
//   const [loading, setLoading] = useState(false);
//   const [accessToken, setAccessToken] = useState('');
//   const [error, setError] = useState(null);
//   const [success, setSuccess] = useState(null);
//   const [currentId, setCurrentId] = useState(null);
//   const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
//   const [options, setOptions] = useState([]);
//   const [searchValue, setSearchValue] = useState('');

//   const [serviceData, setServiceData] = useState({
//     name_en: "",
//     name_fr: "",
//     description_en: "",
//     description_fr: "",
//     image: null,
//     price: "",
//     type: '',
//     status: "active",
//   });

//   const initialState = {
//     name_en: '',
//     name_fr: '',
//     description_en: '',
//     description_fr: '',
//     image: null,
//     price: '',
//     type: '',
//     status: 'active',
//   };

//   const types = [
//     { value: "single_selection", label: "Single Selection" },
//     { value: "multiple_selection", label: "Multiple Selection" },
//     { value: "input", label: "Input" },
//     { value: "dropdown", label: "Dropdown" },
//   ];

//   // Fetch sliders with pagination
//   const fetchServices = useCallback(
//     async (page, searchValue) => {
//       setLoading(true);
//       try {
//         const params = { page, total: totalItems, search: searchValue };
//         const headers = {
//           "x-access-token": accessToken,
//         };
//         const response = await apiRequest.get(endPoints.GET_SERVICES,
//           params,
//           headers,
//         );

//         if (response.success) {
//           const { items, pagination } = response.data;
//           setServices(items);
//           setTotalPages(pagination.total_pages);
//           setCurrentPage(pagination.current_page);
//           setTotalItems(pagination.totalItems);
//         }
//       } catch (error) {
//         console.error("Error fetching sliders:", error);
//         setError("Failed to fetch sliders. Please try again.");
//       } finally {
//         setLoading(false);
//       }
//     },
//     [accessToken, totalItems]
//   );

//   // Fetch sliders when currentPage changes
//   useEffect(() => {
//     setAccessToken(localStorage.getItem("access_token"));
//     fetchServices(currentPage, searchValue);
//   }, [currentPage, fetchServices, searchValue]);

//   // Handle modal open/close
//   const handleOpenModal = () => {
//     setOpenModal(true);
//     setOptions([])
//     setServiceData(initialState);
//   };
//   const handleCloseModal = () => {
//     setOpenModal(false);
//     setServiceData(initialState);
//     setOptions([])
//     setIsEditing(false);
//   };

//   // Handle form input change
//   const handleInputChange = (e) => {
//     const { name, value } = e.target;
//     setServiceData({ ...serviceData, [name]: value });
//   };

//   // Handle form submission
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);
//     setError(null);
//     setSuccess(null);

//     try {
//       const formData = new FormData();

//       // Append text fields
//       formData.append('name_en', serviceData.name_en);
//       formData.append('name_fr', serviceData.name_fr);
//       formData.append('description_en', serviceData.description_en);
//       formData.append('description_fr', serviceData.description_fr);
//       formData.append('price', serviceData.price);

//       // Append image files
//       if (serviceData.image instanceof File) {
//         formData.append('image', serviceData.image);
//       }

//       if (serviceData.type) {
//         formData.append('type', serviceData.type);
//       }

//       if (serviceData.options && serviceData.options.length > 0) {
//         formData.append('options', JSON.stringify(serviceData.options));
//       }

//       // Determine the endpoint and method based on whether it's an edit or add operation
//       const endPoint = isEditing
//         ? `${endPoints.UPDATE_SERVICE}/${currentId}`
//         : `${endPoints.ADD_SERVICE}`;
//       const requestMethod = isEditing ? apiRequest.put : apiRequest.post;

//       // Send the request
//       const response = await requestMethod(endPoint, formData, {
//         headers: {
//           'Content-Type': 'multipart/form-data',
//           'x-access-token': accessToken,
//         },
//       });

//       // Handle the response
//       if (response.success) {
//         setSuccess(isEditing ? "Slider updated successfully." : "Slider added successfully.");
//         fetchServices(currentPage); // Refresh the slider list
//         handleCloseModal(); // Close the modal
//       } else {
//         setError(response.message || 'Failed to add/update slider.');
//       }
//     } catch (error) {
//       console.error('Error:', error);
//       setError('An error occurred while processing your request.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Handle edit servict type
//   const handleEdit = (service) => {
//     handleOpenModal();
//     setIsEditing(true);

//     const parsedOptions = typeof service.options === "string"
//       ? JSON.parse(service.options)
//       : service.options;

//     setServiceData({
//       name_en: service.name_en || "",
//       name_fr: service.name_fr || "",
//       description_en: service.description_en || "",
//       description_fr: service.description_fr || "",
//       image: service.image || null,
//       price: service.price || null,
//       image_preview: service.image ? `${apiRequest.BASE_URL}/${service.image}` : null,
//       status: service.status || "active",
//       type: service.type || null,
//       options: parsedOptions || []
//     });

//     setOptions(parsedOptions || [])

//     setCurrentId(service.id);
//   };

//   // Handle delete slider
//   const handleDelete = async (id) => {
//     try {
//       setLoading(true);
//       setError(null);
//       setSuccess(null);

//       // Send the DELETE request to the API
//       const response = await apiRequest.delete(
//         `${endPoints.DELETE_SERVICE}/${id}`,
//         {
//           headers: {
//             'x-access-token': accessToken,
//           },
//         }
//       );

//       // Handle the response
//       if (response.success) {
//         setSuccess("Service  deleted successfully.");

//         // Update the local state to remove the deleted slider
//         setServices((prev) => prev.filter((serviceData) => serviceData.id !== id));
//       } else {
//         setError(response.message || "Failed to delete the service.");
//       }
//     } catch (error) {
//       console.error("Error deleting service type:", error);
//       setError("An error occurred while deleting the service type.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   // Handle page change
//   const handlePageChange = (newPage) => {
//     if (newPage > 0 && newPage <= totalPages) {
//       setCurrentPage(newPage); // Update the current page
//     }
//   };

//   const handleFileChange = (e, fieldName) => {
//     const file = e.target.files[0];
//     if (file) {
//       // Update the state with the file and its preview
//       setServiceData((prevState) => ({
//         ...prevState,
//         [fieldName]: file, // Store the file object
//         [`${fieldName}_preview`]: URL.createObjectURL(file), // Generate a preview URL
//       }));
//     }
//   };


//   const handleStatusToggle = async (id, currentStatus) => {
//     try {
//       setLoading(true);
//       setError(null);
//       setSuccess(null);

//       const newStatus = currentStatus === "active" ? "inactive" : "active";
//       const payload = {
//         status: newStatus,
//       };

//       const headers = {
//         'Content-Type': 'application/json',
//         'x-access-token': accessToken,
//       };

//       // Send the PUT request to update the slider status
//       const response = await apiRequest.put(
//         `${endPoints.STATUS_SERVICE}/${id}`,
//         payload,
//         { headers }
//       );

//       // Handle the response
//       if (response.success) {
//         setSuccess("Service status updated successfully.");

//         // Update the local state immediately
//         setServices((prevServiceData) =>
//           prevServiceData.map((serviceData) =>
//             serviceData.id === id ? { ...serviceData, status: newStatus } : serviceData
//           )
//         );
//       } else {
//         setError(response.message || 'Failed to update service status.');
//       }
//     } catch (error) {
//       console.error('Error updating service type status:', error);
//       setError('An error occurred while updating the service type status.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleAddOption = () => {
//     setOptions([...options, ""]); // Add an empty string to the options array
//   };

//   const handleOptionChange = (index, key, value) => {
//     const updatedOptions = [...options];
//     updatedOptions[index] = { [key]: value }; // Ensure the key is defined
//     setOptions(updatedOptions);

//     // Update serviceData with the new options
//     setServiceData((prevState) => ({
//       ...prevState,
//       options: updatedOptions,
//     }));
//   };

//   // Function to remove an option
//   const handleRemoveOption = (index) => {
//     const updatedOptions = options.filter((_, i) => i !== index); // Remove the option at the specified index
//     setOptions(updatedOptions);

//     // Update serviceData with the remaining options
//     setServiceData((prevState) => ({
//       ...prevState,
//       options: updatedOptions,
//     }));
//   };

//   return (
//     <DashboardLayout>
//       <DashboardNavbar />
//       <MDBox pt={6} pb={3}>
//         <Grid container spacing={6}>
//           <Grid item xs={12}>
//             <Card>
//               <MDBox
//                 mx={2}
//                 mt={-3}
//                 py={3}
//                 px={2}
//                 variant="gradient"
//                 bgColor="info"
//                 borderRadius="lg"
//                 coloredShadow="info"
//               >
//                 <MDTypography variant="h6" color="white">
//                   Services
//                 </MDTypography>
//               </MDBox>
//               <MDBox pt={1} px={1}>
//                 <MDBox
//                   pt={1}
//                   px={1}
//                   display="flex"
//                   justifyContent="flex-end"
//                   alignItems="center"
//                   gap={2}
//                 >
//                   <TextField
//                     label="Search"
//                     variant="outlined"
//                     margin="normal"
//                     placeholder="Search by title or description"
//                     style={{ width: "300px" }}
//                     value={searchValue}
//                     onChange={(e) => setSearchValue(e.target.value)}
//                   />
//                   <Button
//                     variant="contained"
//                     color="primary"
//                     onClick={handleOpenModal}
//                     style={{
//                       whiteSpace: "nowrap",
//                       color: "white",
//                     }}
//                   >
//                     Add Service
//                   </Button>
//                 </MDBox>
//                 <TableContainer component={Paper} style={{ marginTop: "1px" }}>
//                   <Table>
//                     <TableBody>
//                       <TableRow>
//                         <TableCell style={{ fontWeight: "bold" }}>Name</TableCell>
//                         <TableCell style={{ fontWeight: "bold" }}>Type</TableCell>
//                         <TableCell style={{ fontWeight: "bold" }}>Options</TableCell>
//                         <TableCell style={{ fontWeight: "bold" }}>Price</TableCell>
//                         <TableCell style={{ fontWeight: "bold" }}>Photo</TableCell>
//                         <TableCell style={{ fontWeight: "bold" }}>Status</TableCell>
//                         <TableCell style={{ fontWeight: "bold" }}>Actions</TableCell>
//                       </TableRow>
//                       {services.map((service) => (
//                         <TableRow key={service.id}>
//                           <TableCell>{service.name_en + ' / ' + service.name_fr}</TableCell>
//                           <TableCell>
//                             {service.type ? (types.find(type => type.value === service.type)?.label || '') : ''}
//                           </TableCell>
//                           <TableCell>
//                             <ul style={{ listStyleType: "disc", paddingLeft: "20px", margin: 0 }}>
//                               {(Array.isArray(service.options) ? service.options : JSON.parse(service.options || "[]")).map(
//                                 (option, index) => {
//                                   const [value] = Object.entries(option)[0];
//                                   return <li key={index}>{`${value}`}</li>;
//                                 }
//                               )}
//                             </ul>
//                           </TableCell>
//                           <TableCell>{service.price}</TableCell>
//                           <TableCell>
//                             {service.image && (
//                               <img
//                                 src={`${apiRequest.BASE_URL}/${service.image}`}
//                                 alt={service.name_en}
//                                 style={{ width: "100px", height: "auto" }}
//                               />
//                             )}
//                           </TableCell>
//                           <TableCell>
//                             <Switch
//                               checked={service.status === "active"} // Assuming "active" is the active status
//                               onChange={() => handleStatusToggle(service.id, service.status)}
//                               color="primary"
//                             />
//                           </TableCell>
//                           <TableCell>
//                             <Box
//                               sx={{
//                                 display: "flex",
//                                 alignItems: "center",
//                                 gap: 1, // space between buttons
//                               }}
//                             >
//                               <Button
//                                 onClick={() => handleEdit(service)}
//                                 color="primary"
//                                 size="small"
//                               >
//                                 Edit
//                               </Button>
//                               <Button
//                                 onClick={() => {
//                                   setCurrentId(service.id); // Set the service ID to delete
//                                   setDeleteDialogOpen(true); // Open the confirmation dialog
//                                 }}
//                                 color="error"
//                                 size="small"
//                               >
//                                 Delete
//                               </Button>
//                             </Box>
//                           </TableCell>

//                         </TableRow>
//                       ))}
//                     </TableBody>
//                   </Table>
//                 </TableContainer>

//                 {/* Pagination Controls */}
//                 <MDBox mt={2} display="flex" justifyContent="center" alignItems="center">
//                   <Button
//                     onClick={() => handlePageChange(currentPage - 1)}
//                     disabled={currentPage === 1}
//                   >
//                     Previous
//                   </Button>
//                   <MDTypography mx={2}>
//                     Page {currentPage} of {totalPages} {/* Display current page and total pages */}
//                   </MDTypography>
//                   <Button
//                     onClick={() => handlePageChange(currentPage + 1)}
//                     disabled={currentPage === totalPages}
//                   >
//                     Next
//                   </Button>
//                 </MDBox>
//               </MDBox>
//             </Card>
//           </Grid>
//         </Grid>
//       </MDBox>
//       <Footer />

//       {/* Modal for Adding/Editing Service Type */}
//       <Modal open={openModal} onClose={handleCloseModal}>
//         <MDBox
//           p={3}
//           bgcolor="white"
//           borderRadius="lg"
//           style={{
//             width: 900,
//             margin: "50px auto",
//             outline: "none",
//             backgroundColor: "white",
//             maxHeight: "80vh", // Limit the height of the modal
//             overflowY: "auto", // Enable vertical scrolling
//           }}
//         >
//           <MDTypography variant="h6" mb={2}>
//             {isEditing ? "Edit Service" : "Add Service"}
//           </MDTypography>
//           <form onSubmit={handleSubmit}>
//             <Grid container spacing={2}>
//               {/* Title (EN) */}
//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   fullWidth
//                   label="Title (EN)"
//                   name="name_en"
//                   value={serviceData.name_en}
//                   onChange={handleInputChange}
//                   margin="normal"
//                   required
//                 />
//               </Grid>

//               {/* Title (FR) */}
//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   fullWidth
//                   label="Title (FR)"
//                   name="name_fr"
//                   value={serviceData.name_fr}
//                   onChange={handleInputChange}
//                   margin="normal"
//                   required
//                 />
//               </Grid>

//               {/* Description (EN) */}
//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   fullWidth
//                   label="Description (EN)"
//                   name="description_en"
//                   value={serviceData.description_en}
//                   onChange={handleInputChange}
//                   margin="normal"
//                   multiline
//                   rows={3}
//                 />
//               </Grid>

//               {/* Description (FR) */}
//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   fullWidth
//                   label="Description (FR)"
//                   name="description_fr"
//                   value={serviceData.description_fr}
//                   onChange={handleInputChange}
//                   margin="normal"
//                   multiline
//                   rows={3}
//                 />
//               </Grid>

//               <Grid item xs={12} sm={6}>
//                 <Autocomplete
//                   options={types}
//                   getOptionLabel={(option) => option.label}
//                   value={types.find((type) => type.value === serviceData.type) || null}
//                   onChange={(event, newValue) => {
//                     setServiceData({
//                       ...serviceData,
//                       type: newValue ? newValue.value : null,
//                     });
//                   }}
//                   renderInput={(params) => <TextField {...params} label="Select Type" />}
//                   style={{ margin: '15px 0' }}
//                 />
//               </Grid>

//               <Grid item xs={12} sm={6}>
//                 <TextField
//                   fullWidth
//                   label="Price"
//                   name="price"
//                   value={serviceData.price}
//                   onChange={handleInputChange}
//                   margin="normal"
//                 />
//               </Grid>

//               <Grid item xs={12} sm={6}>
//                 <div style={{ display: 'flex', alignItems: 'center' }}>
//                   <input
//                     type="file"
//                     id="file-input"
//                     onChange={(e) => handleFileChange(e, 'image')}
//                     style={{ display: 'none' }}
//                   />
//                   <label htmlFor="file-input">
//                     <Button variant="outlined" component="span" style={{ width: '100%', color: 'gray', margin: "20px 0" }}>
//                       Upload Image
//                     </Button>
//                   </label>
//                   {serviceData.image_preview && (
//                     <img
//                       src={serviceData.image_preview}
//                       alt="Preview"
//                       style={{ width: '100px', height: 'auto', marginLeft: '10px' }}
//                     />
//                   )}
//                 </div>
//               </Grid>

//               <Grid item xs={12}>
//                 <Button
//                   variant="outlined"
//                   onClick={handleAddOption}
//                   style={{ width: "20%", color: "gray", marginBottom: "16px" }}
//                 >
//                   Add Option
//                 </Button>

//                 {/* Render dynamic option fields */}
//                 <Grid container spacing={2}>
//                   {options.map((option, index) => (
//                     <Grid item xs={6} sm={3} key={index}>
//                       <TextField
//                         fullWidth
//                         label={`Option ${index + 1}`}
//                         value={Object.values(option)[0] || ""} // Get the value of the first key
//                         required
//                         onChange={(e) =>
//                           handleOptionChange(index, `Option${index + 1}`, e.target.value) // Pass the key explicitly
//                         }
//                         margin="normal"
//                         InputProps={{
//                           endAdornment: (
//                             <InputAdornment position="end">
//                               <IconButton
//                                 onClick={() => handleRemoveOption(index)}
//                                 color="error"
//                                 size="small"
//                               >
//                                 <DeleteIcon />
//                               </IconButton>
//                             </InputAdornment>
//                           ),
//                         }}
//                       />
//                     </Grid>
//                   ))}
//                 </Grid>
//               </Grid>
//             </Grid>

//             <MDBox mt={3} display="flex" justifyContent="flex-end">
//               <Button
//                 type="submit"
//                 variant="contained"
//                 color="primary"
//                 style={{
//                   whiteSpace: "nowrap",
//                   color: "white",
//                 }}
//               >
//                 {isEditing ? "Update" : "Add"}
//               </Button>
//             </MDBox>
//           </form>
//         </MDBox>
//       </Modal>

//       {/* Delete Confirmation Dialog */}
//       <Dialog
//         open={deleteDialogOpen}
//         onClose={() => setDeleteDialogOpen(false)}
//         aria-labelledby="delete-dialog-title"
//         aria-describedby="delete-dialog-description"
//       >
//         <DialogTitle id="delete-dialog-title">Delete Service</DialogTitle>
//         <DialogContent>
//           <DialogContentText id="delete-dialog-description">
//             Are you sure you want to delete this service? This action cannot be undone.
//           </DialogContentText>
//         </DialogContent>
//         <DialogActions>
//           <Button onClick={() => setDeleteDialogOpen(false)} color="primary">
//             Cancel
//           </Button>
//           <Button
//             onClick={() => {
//               setDeleteDialogOpen(false); // Close the dialog
//               handleDelete(currentId); // Proceed with deletion
//             }}
//             color="error"
//             variant="contained"
//           >
//             Delete
//           </Button>
//         </DialogActions>
//       </Dialog>

//       {/* Loading Backdrop */}
//       <Backdrop
//         sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
//         open={loading}
//       >
//         <CircularProgress color="inherit" />
//       </Backdrop>

//       {/* Error/Success Snackbar */}
//       <Snackbar
//         open={!!error || !!success}
//         autoHideDuration={3000}
//         onClose={() => {
//           setError(null);
//           setSuccess(null);
//         }}
//         anchorOrigin={{ vertical: 'top', horizontal: 'right' }} // Positioning the Snackbar
//       >
//         <Alert
//           onClose={() => {
//             setError(null);
//             setSuccess(null);
//           }}
//           severity={error ? "error" : "success"}
//           sx={{ width: '100%' }}
//         >
//           {error || success}
//         </Alert>
//       </Snackbar>

//     </DashboardLayout>
//   );
// }

// export default ServiceComponent;
import React, { useState } from "react";
import { Grid, Card, Button, TextField, Backdrop, CircularProgress, Alert, Snackbar } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import Footer from "examples/Footer";
import apiRequest from "apiRequest";
// import useServices from "features/services/hooks/useServices";

import ServiceTable from "./components/ServiceTable";
import ServiceFormModal from "./components/ServiceFormModal";
import DeleteDialog from "./components/DeleteDialog";
import useServices from "features/services/hooks/useServices";

const INITIAL_SERVICE_STATE = {
  name_en: "",
  name_fr: "",
  service_type_id: "",
  description_en: "",
  description_fr: "",
  image: null,
  image_preview: null,
  is_required: false,
  type: "",
  status: "active",
  options: [],
};

const SERVICE_OPTION_TEMPLATE = { name_en: "", name_fr: "", price: "" };

const SERVICE_TYPES_OPTIONS = [
  { value: "single_selection", label: "Single Selection" },
  { value: "multiple_selection", label: "Multiple Selection" },
  { value: "input", label: "Input" },
  { value: "drop-down", label: "Dropdown" },
];

function ServiceComponent() {
  const [openModal, setOpenModal] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [currentId, setCurrentId] = useState(null);
  const [deleteDialogOpen, setDeleteDialogOpen] = useState(false);
  const [options, setOptions] = useState([]);
  const [serviceData, setServiceData] = useState(INITIAL_SERVICE_STATE);

  const {
    services,
    serviceTypes,
    searchValue,
    setSearchValue,
    currentPage,
    totalPages,
    loading,
    error,
    success,
    handleCreate,
    handleUpdate,
    handleDelete,
    handleStatusToggle,
    handlePageChange,
    resetAlerts,
  } = useServices();

  const handleOpenModal = () => {
    setServiceData(INITIAL_SERVICE_STATE);
    setOptions([]);
    setIsEditing(false);
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    setServiceData(INITIAL_SERVICE_STATE);
    setOptions([]);
    setIsEditing(false);
    setCurrentId(null);
  };

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setServiceData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleFileChange = (event, fieldName) => {
    const file = event.target.files?.[0];
    if (!file) return;

    setServiceData((prev) => ({
      ...prev,
      [fieldName]: file,
      [`${fieldName}_preview`]: URL.createObjectURL(file),
    }));
  };

  const buildFormData = () => {
    const formData = new FormData();

    formData.append("name_en", serviceData.name_en);
    formData.append("name_fr", serviceData.name_fr);
    formData.append("description_en", serviceData.description_en);
    formData.append("description_fr", serviceData.description_fr);
    formData.append("is_required", serviceData.is_required || false);

    if (serviceData.type) {
      formData.append("type", serviceData.type);
    }

    if (serviceData.service_type_id) {
      formData.append("service_type_id", serviceData.service_type_id);
    }

    const optionSource = Array.isArray(serviceData.options) && serviceData.options.length
      ? serviceData.options
      : Array.isArray(serviceData.service_options)
      ? serviceData.service_options
      : [];

    if (optionSource.length > 0) {
      const sanitizedOptions = optionSource
        .filter((option) => option?.name_en?.trim() || option?.name_fr?.trim())
        .map((option) => {
          const payload = {
            name_en: option.name_en || "",
            name_fr: option.name_fr || "",
          };

          if (option.id) {
            payload.id = option.id;
          }

          const priceValue = option.price ?? option.option_price ?? option.pivot?.price;
          if (priceValue !== "" && priceValue !== undefined && priceValue !== null && !Number.isNaN(Number(priceValue))) {
            payload.price = Number(priceValue);
          }

          return payload;
        });

      formData.append("options", JSON.stringify(sanitizedOptions));
    }

    if (serviceData.image instanceof File) {
      formData.append("image", serviceData.image);
    }

    return formData;
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    const formData = buildFormData();
    const action = isEditing
      ? handleUpdate(currentId, formData)
      : handleCreate(formData);

    const result = await action;
    if (result?.success) {
      handleCloseModal();
    }
  };

  const handleEdit = (service) => {
    setIsEditing(true);
    setCurrentId(service.id);

    const rawOptions = service.service_options ?? [];
    const parsedOptions = typeof rawOptions === "string" ? JSON.parse(rawOptions) : rawOptions;

    const normalizedOptions = (parsedOptions || []).map((option) => {
      const base = {
        id: option?.id,
        name_en: option?.name_en || "",
        name_fr: option?.name_fr || "",
        price: option?.price !== undefined && option?.price !== null ? String(option.price) : "",
      };

      if (!base.id) {
        delete base.id;
      }

      return base;
    });

    setServiceData({
      name_en: service.name_en || "",
      name_fr: service.name_fr || "",
      service_type_id: service.service_type_id || service.service_type?.id || "",
      description_en: service.description_en || "",
      description_fr: service.description_fr || "",
      image: service.image || null,
      image_preview: service.image ? `${apiRequest.BASE_URL}/${service.image}` : null,
      is_required: service.is_required || false,
      type: service.type === "dropdown" ? "drop-down" : (service.type || ""),
      status: service.status || "active",
      options: normalizedOptions,
    });

    setOptions(normalizedOptions);
    setOpenModal(true);
  };

  const handleDeleteClick = (id) => {
    setCurrentId(id);
    setDeleteDialogOpen(true);
  };

  const handleDeleteConfirm = async () => {
    setDeleteDialogOpen(false);
    if (!currentId) return;

    const result = await handleDelete(currentId);
    if (result?.success) {
      setCurrentId(null);
    }
  };

  const handleAddOption = () => {
    const newOption = { ...SERVICE_OPTION_TEMPLATE };
    setOptions((prev) => [...prev, newOption]);
    setServiceData((prev) => ({
      ...prev,
      options: [...(prev.options || []), newOption],
    }));
  };

  const handleOptionChange = (index, key, value) => {
    const updatedOptions = options.map((option, optionIndex) =>
      optionIndex === index ? { ...option, [key]: value } : option
    );

    setOptions(updatedOptions);
    setServiceData((prev) => ({
      ...prev,
      options: updatedOptions,
    }));
  };

  const handleRemoveOption = (index) => {
    const updatedOptions = options.filter((_, optionIndex) => optionIndex !== index);
    setOptions(updatedOptions);
    setServiceData((prev) => ({
      ...prev,
      options: updatedOptions,
    }));
  };

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox pt={6} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={3}
                px={2}
                variant="gradient"
                bgColor="info"
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Services
                </MDTypography>
              </MDBox>
              <MDBox pt={1} px={1}>
                <MDBox
                  pt={1}
                  px={1}
                  display="flex"
                  justifyContent="flex-end"
                  alignItems="center"
                  gap={2}
                >
                  <TextField
                    label="Search"
                    variant="outlined"
                    margin="normal"
                    placeholder="Search by title or description"
                    style={{ width: "300px" }}
                    value={searchValue}
                    onChange={(event) => setSearchValue(event.target.value)}
                  />
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleOpenModal}
                    style={{
                      whiteSpace: "nowrap",
                      color: "white",
                    }}
                  >
                    Add Service
                  </Button>
                </MDBox>

                <ServiceTable
                  services={services}
                  types={SERVICE_TYPES_OPTIONS}
                  onStatusToggle={handleStatusToggle}
                  onEdit={handleEdit}
                  onDeleteClick={handleDeleteClick}
                />

                <MDBox mt={2} display="flex" justifyContent="center" alignItems="center">
                  <Button
                    onClick={() => handlePageChange(currentPage - 1)}
                    disabled={currentPage === 1}
                  >
                    Previous
                  </Button>
                  <MDTypography mx={2}>
                    Page {currentPage} of {totalPages}
                  </MDTypography>
                  <Button
                    onClick={() => handlePageChange(currentPage + 1)}
                    disabled={currentPage === totalPages}
                  >
                    Next
                  </Button>
                </MDBox>
              </MDBox>
            </Card>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />

      <ServiceFormModal
        open={openModal}
        handleClose={handleCloseModal}
        isEditing={isEditing}
        serviceData={serviceData}
        options={options}
        types={SERVICE_TYPES_OPTIONS}
        serviceTypes={serviceTypes}
        handleInputChange={handleInputChange}
        handleFileChange={handleFileChange}
        handleSubmit={handleSubmit}
        handleAddOption={handleAddOption}
        handleOptionChange={handleOptionChange}
        handleRemoveOption={handleRemoveOption}
      />

      <DeleteDialog
        open={deleteDialogOpen}
        handleClose={() => setDeleteDialogOpen(false)}
        handleDeleteConfirm={handleDeleteConfirm}
      />

      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>

      <Snackbar
        open={!!error || !!success}
        autoHideDuration={3000}
        onClose={resetAlerts}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
      >
        <Alert
          onClose={resetAlerts}
          severity={error ? "error" : "success"}
          sx={{ width: "100%" }}
        >
          {error || success}
        </Alert>
      </Snackbar>
    </DashboardLayout>
  );
}

export default ServiceComponent;
